import React from "react";
import { createRoot } from "react-dom/client";
import CssBaseline from "@mui/material/CssBaseline";
import { BrowserRouter } from "react-router-dom";
import { StoreProvider } from "state/store";
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { ThemeProvider as StylesThemeProvider } from "@mui/styles";
import theme from "views/style/theme";
import App from "views/App";
import * as serviceWorker from "./serviceWorker";

function Kampose() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <StyledEngineProvider injectFirst>
          <MuiThemeProvider theme={theme}>
            <StylesThemeProvider theme={theme}>
              <CssBaseline />
              <App />
            </StylesThemeProvider>
          </MuiThemeProvider>
        </StyledEngineProvider>
      </BrowserRouter>
    </StoreProvider>
  );
}

const root = createRoot(document.getElementById("root"));
root.render(<Kampose />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
